import Locale from '../Entities/Locale.js';

function LocaleService (apiInstance)
{
  const api = apiInstance;

  this.create = (key, name) => {
    let data = {key: key, name: name};

    return api.request('POST', data, '/locales', {})
      .then(function (response) {
        const data = response.data.data;
        return new Locale(data.locale);
      })
      .catch(function (error) {
        throw error;
      });
  }

  this.update = (locale, key, value) => {
    let data = {};
    data[key] = value;
    return api.request('PUT', data, '/locales/' + locale, {})
      .then(function (response) {
      })
      .catch(function (error) {
        throw error;
      });
  }

  this.delete = (locale) => {
    return api.request('DELETE', null, '/locales/' + locale, {})
  }

  this.duplicate = (locale) => {
    return api.request('POST', null, '/locales/' + locale + '/duplicate', {})
      .then(function (response) {
        const data = response.data.data;
        return new Locale(data.locale);
      })
      .catch(function (error) {
        throw error;
      });
  }

  this.fetch = (locale) => {
    return api.request('GET', null, '/locales', {})
      .then(function (response) {
        const data = response.data.data;
        return data.locales.map(function (data) {
          return new Locale(data);
        })
      })
      .catch(function (response) {
        throw response;
      });
  }

  return this;
}

export default LocaleService;


// WEBPACK FOOTER //
// ./src/Services/LocaleService.js